import { jsx as _jsx } from "react/jsx-runtime";
import { Check, ChevronLeft, Download, Eye, EyeOff, StickyNote, Trash2 } from "lucide-react";
/**
 * Iconography, with the house rules applied in one place instead of at every call
 * site. Lucide is the set (design_system_readme.md, ICONOGRAPHY): 1.5px stroke on a
 * 24px grid, and it suits the system because its stroke weight matches the 1px line
 * language and it has no filled or rounded variants to tempt anyone.
 */
export const iconDefaults = {
    size: 24,
    strokeWidth: 1.5,
    absoluteStrokeWidth: true,
};
export function Icon({ icon: Glyph, ...rest }) {
    return _jsx(Glyph, { ...iconDefaults, ...rest, color: "currentColor" });
}
/**
 * The download arrow, 16px for a Button's `iconLeft` (`Download the recorder`, issue 197), 17 in a
 * menu (`Download transcript`, issue 201).
 */
export function DownloadIcon({ size = 16 } = {}) {
    return _jsx(Icon, { icon: Download, size: size, "aria-hidden": "true" });
}
/** The bin, 17px, for a menu item (`Delete session`, issue 201). */
export function TrashIcon({ size = 17 } = {}) {
    return _jsx(Icon, { icon: Trash2, size: size, "aria-hidden": "true" });
}
/** The note glyph, 14px, beside the word `Note` on a transcript row (design-spec §4, issue 202). */
export function NoteIcon() {
    return _jsx(Icon, { icon: StickyNote, size: 14, "aria-hidden": "true" });
}
/** The back chevron, 16px, for `BackLink` (variant E `I.back`). */
export function BackIcon() {
    return _jsx(Icon, { icon: ChevronLeft, size: 16, "aria-hidden": "true" });
}
/** The eye, 16px, for the session head's `Show video` (variant E `I.eye`, issue 203). */
export function EyeIcon() {
    return _jsx(Icon, { icon: Eye, size: 16, "aria-hidden": "true" });
}
/** The struck eye, 16px, for the session head's `Hide video` (variant E `I.eyeOff`, issue 203). */
export function EyeOffIcon() {
    return _jsx(Icon, { icon: EyeOff, size: 16, "aria-hidden": "true" });
}
/** The check, 16px, for a knowledge item's `Keep` and `Kept` (variant E `I.check`, issue 204). */
export function CheckIcon() {
    return _jsx(Icon, { icon: Check, size: 16, "aria-hidden": "true" });
}
